// Package Imports
import {
  BaseRecord,
  CrudFilters,
  HttpError,
  useTranslate,
} from '@refinedev/core';
import { useTable } from '@refinedev/antd';
import { Card, Typography } from 'antd';
import { useEffect, useState } from 'react';
// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import { FilterVariables, IPost } from 'pages/unificationList/interface';
import scrollToTop from 'core/utils/scrollToTop';
import UnificationHistoryTable from 'pages/unificationList/unificationHistoryTable';
import Filter from 'pages/unificationList/filter';
import getFilteFormattedDate from 'core/utils/getFilteFormattedDate';
import useLogger from 'core/utils/useLogger';
import { useSocketNotificationContext } from 'contexts/socketNotificationContext/SocketNotificationContext';

export const UnificationHistoryView = () => {
  const t = useTranslate();
  const logger = useLogger();
  const { Title } = Typography;
  const { initiateUnification } = useSocketNotificationContext();
  const [frequencyName, setFrequencyName] = useState<string>();
  const [frequencyType, setFrequencyType] = useState<string>();
  const [timelineType, setTimelineType] = useState<boolean>(true);
  const { tableQueryResult, tableProps, searchFormProps, setFilters } =
    useTable<IPost, HttpError, FilterVariables>({
      resource: apiEndpoint.unificationRunMaster,
      dataProviderName: 'payoutProvider',
      onSearch: (params) => {
        const filters: CrudFilters = [];
        const { frequency, date, status } = params;
        filters.push(
          {
            field: 'frequency_id',
            operator: 'contains',
            value: frequency,
          },
          {
            field: 'date',
            operator: 'contains',
            value: date
              ? getFilteFormattedDate(frequencyName, date, timelineType)
              : null,
          },
          {
            field: 'status',
            operator: 'contains',
            value: status,
          }
        );
        return filters;
      },
      syncWithLocation: false,
    });

  const { refetch } = tableQueryResult;
  const fetchData = async () => {
    try {
      await refetch();
    } catch (error) {
      logger('Error refetching data:', error);
    }
  };
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchData();
  }, [initiateUnification]);

  const unificationHistoryTableData = (
    tableQueryResult?.data?.data as BaseRecord
  )?.results;

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Card>
      {/* <Card className="card-style flex items-center">
        <h4 className="card-title">{t('unificationList.title')}</h4>
      </Card> */}
      <Title level={4}>{t('unificationList.title')}</Title>

      <Filter
        setFilters={setFilters}
        formProps={searchFormProps}
        setFrequencyName={setFrequencyName}
        frequencyName={frequencyName}
        timelineType={timelineType}
        setTimelineType={setTimelineType}
        frequencyType={frequencyType}
        setFrequencyType={setFrequencyType}
      />
      <UnificationHistoryTable
        tableProps={tableProps}
        unificationHistoryTableData={unificationHistoryTableData}
        tableQueryResult={tableQueryResult}
      />
    </Card>
  );
};
export default UnificationHistoryView;
